import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly LANGUAGE_KEY = 'language';
  private readonly LANGUAGE_STORAGE_KEY = 'fixz_language';

  constructor() {
    // Initialize language from localStorage on service creation
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    let code = this.getLanguageFromStorage();
    
    if (!code) {
      // Fallback to browser language or 'en'
      const browser = navigator.language || (navigator as any).userLanguage || 'en';
      code = browser.startsWith('ar') ? 'ar' : 'en';
      this.setLanguage(code);
    } else {
      // Apply the stored language without persisting again
      this.applyLanguage(code);
    }
  }

  setLanguage(code: string): void {
    // Store in localStorage
    localStorage.setItem(this.LANGUAGE_STORAGE_KEY, code);
    // Apply to DOM
    this.applyLanguage(code);
  }

  private applyLanguage(code: string): void {
    try {
      document.documentElement.lang = code;
      if (code === 'ar') {
        document.documentElement.dir = 'rtl';
        document.body.classList.add('rtl');
      } else {
        document.documentElement.dir = 'ltr';
        document.body.classList.remove('rtl');
      }
    } catch (e) {
      // non-browser environment
    }
  }

  private getLanguageFromStorage(): string | null {
    return localStorage.getItem(this.LANGUAGE_STORAGE_KEY);
  }

  get current(): string {
    const stored = this.getLanguageFromStorage();
    return stored || 'en';
  }
}
